import React, {Component} from "react";
import {
    AppBar, Button, Tab, Tabs,
    Dialog, DialogContent, DialogActions
} from "@material-ui/core";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import RentTab from "./RentTab";
import LogTab from "./LogTab";
import RemarkTab from "./RemarkTab"
import ActionCreator from './../../../../../../store/actions/index';
import PropTypes from "prop-types";
import t from "../../../../../../languages/pl";

const styles = theme => ({
    container: {
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "column",
        paddingBottom: theme.spacing(1)
    },
    textField: {
        margin: theme.spacing(1),
        width: 200
    },
    dialogPaper: {
        height: "80vh"
    },
    pointer: {
        cursor: "pointer"
    }
});

class ReservationDialog extends Component {

    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps) {
        if (this.props.carPool !== prevProps.carPool || this.props.carRent !== prevProps.carRent) {
            if (this.props.isEdit) {
                this.setState({
                    carPool: {...this.props.carPool},
                    carRent: {...this.props.carRent}
                })
            } else {
                this.setState({
                    carPool: {...initialPool},
                    carRent: {...initialCarRent}
                })
            }
        }
        if (this.props.remarks !== prevProps.remarks) {
            this.setState({
                remarks: [...this.props.remarks]
            })
        }
        if (this.props.changes !== prevProps.changes) {
            this.setState({
                changes: [...this.props.changes]
            })
        }
    }

    state = {
        carRent: {...this.props.carRent},
        carPool: {...this.props.carPool},
        remarks: [],
        changes: [],
        isError: false,
        isClientNameEmpty: false,
        isChecked: false,
        value: 0,
        selectedClient: "",
        car: null,
        cars: [],
    };

    handleTabChange = (event, value) => {
        this.setState({value});
    };

    handleSaveAndClose() {
        if (this.props.rentType === "Pool") {
            this.props.onPutPoolAndClose(this.props.carId, this.props.carPool.wynajem_id, this.state.carPool)
            this.setState({
                carPool: {...initialPool}
            })
        } else {
            this.props.onPutRentAndClose(this.props.carId, this.props.carRent.wynajem_id, this.state.carRent)
            this.setState({
                carRent: {...initialCarRent}
            })
        }
        this.setState({
            value: 0
        })
    }

    handleSave() {
        if (this.props.rentType === "Pool") {
            this.props.onPutPool(this.props.carId, this.props.carPool.wynajem_id, this.state.carPool);
        } else {
            this.props.onPutRent(this.props.carId, this.props.carRent.wynajem_id, this.state.carRent);
        }
        this.setState({
            value: 0
        })
    }

    handleAddRent() {
        if (this.props.rentType === "Pool") {
            this.props.onAddPool(this.state.carPool);
            this.setState({
                carPool: {...initialPool}
            })
        } else {
            this.props.onAddRent(this.state.carRent);
            this.setState({
                carRent: {...initialCarRent}
            })
        }
    }

    handleCheckPoolValidation() {
        if (this.state.carPool.kierowca_id === 0
            || (isNaN(this.state.carPool.data_do) || this.state.carPool.data_do === 0)
            || (isNaN(this.state.carPool.data_od) || this.state.carPool.data_od === 0)) {
            this.setState({
                isError: true
            })
        } else {
            this.setState({
                isError: false
            })
        }
    }

    handleCheckRentValidation() {
        if (this.state.carRent.data_od === 0) {
            this.setState({
                isError: true,
            })
        } else {
            this.setState({
                isError: false
            })
        }
    }

    handleCheckClientNameValidation() {
        if (this.state.carRent.klient.nazwa === "") {
            this.setState({
                isError: true,
                isClientNameEmpty: true
            })
        } else {
            this.setState({
                isClientNameEmpty: false
            })
        }
        if (this.state.carRent.klient.nazwa !== "" && this.state.carRent.data_od !== 0) {
            this.setState({
                isError: false,
            })
        }
    }

    handleDeleteRent() {
        if (this.props.rentType === "Pool") {
            this.props.onDeletePool(this.state.carPool.wynajem_id);

        } else {
            this.props.onDeleteRent(this.state.carRent.wynajem_id);
        }
        this.setState({
            value: 0
        })
    }

    handleCancel() {
        this.setState({
            carPool: {...initialPool},
            carRent: {...initialCarRent},
            value: 0
        })
        this.props.closeDialog();
    }

    handleCheckboxChange(value) {
        this.setState({
            isChecked: value
        })
    }

    render() {
        const {isEdit} = this.props;
        const {value, car} = this.state;

        return (
            <Dialog
                open={this.props.isDialogOpen}
                onClose={this.props.closeDialog}
                fullScreen={true}
                // fullScreen={this.props.rentType !== "Pool" ? true : false}
            >
                <DialogContent>
                    <h3>
                        Najem samochodu: {car && <>{car.rejestracja} - {car.marka} {car.model} {car.opis}</>}
                    </h3>
                    <AppBar position="relative">
                        <Tabs
                            variant="scrollable"
                            value={value}
                            onChange={this.handleTabChange}
                        >
                            <Tab label={this.props.rentType === "Pool" ? t.poolManagement : t.rentalManagement}/>
                            {isEdit && <Tab label={t.rentalChangeRegister}/>}
                        </Tabs>
                    </AppBar>
                    {value === 0 && (
                        <RentTab
                            rent={this.props.rentType === "Pool" ? this.state.carPool : this.state.carRent}
                            isError={this.state.isClientNameEmpty}
                            clients={this.props.clients}
                            isEdit={isEdit}
                            selectedClient={this.state.selectedClient}
                            rentType={this.props.rentType}
                            checkPoolValidation={this.handleCheckPoolValidation.bind(this)}
                            checkRentValidation={this.handleCheckRentValidation.bind(this)}
                            checkClientNameValidation={this.handleCheckClientNameValidation.bind(this)}
                            onCheckboxChange={this.handleCheckboxChange.bind(this)}
                        />
                    )}
                    {value === 1 && (
                        <React.Fragment>
                            <RemarkTab remarks={this.state.remarks}/>
                            <LogTab changes={this.state.changes}/>
                        </React.Fragment>)}
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleCancel.bind(this)}>Anuluj</Button>
                    {isEdit
                        ?
                        <>
                            <Button onClick={this.handleDeleteRent.bind(this)}>Usuń</Button>
                            <Button
                                color="primary"
                                disabled={this.state.isError}
                                onClick={this.handleSave.bind(this)}
                            >
                                {t.save}
                            </Button>
                            <Button
                                disabled={this.state.isError}
                                color="secondary"
                                onClick={this.handleSaveAndClose.bind(this)}
                            >
                                {t.saveAndClose}
                            </Button>
                        </>
                        :
                        <>
                            <Button
                                disabled={this.state.isError}
                                color="secondary"
                                style={{paddingRight: "16px", marginRight: "16px"}}
                                onClick={this.handleAddRent.bind(this)}
                            >
                                {t.add}
                            </Button>
                        </>}

                </DialogActions>
            </Dialog>
        );
    }
}

const mapStateToProps = state => {
    return {
        clients: state.rentReducer.clients,
        // cars: state.formReducer.cars,
        carRent: state.carsReducer.carRent,
        carPool: state.carsReducer.carPool,
        remarks: state.carsReducer.remarks,
        changes: state.carsReducer.changes,
    };
};


const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
}

const initialPool = {
    cel_podrozy: "",
    data_do: 0,
    data_od: 0,
    kierowca_id: 0,
    kierowca_nazwa: "",
    rozpoczal: "",
    wynajem_id: 0,
    zakonczyl: ""
};

const initialCarRent = {
    data_do: 0,
    data_od: 0,
    kierowca: {
        data_prawa: 0,
        imie: "",
        kod: "",
        miasto: "",
        organ: "",
        pesel: "",
        prawo: "",
        telefon: "",
        ulica: ""
    },
    kierowca_dodatkowy: {
        data_prawa: 0,
        imie: "",
        kod: "",
        miasto: "",
        organ: "",
        pesel: "",
        prawo: "",
        telefon: "",
        ulica: ""
    },
    klient: {
        dowod: "",
        email: "",
        kod: "",
        miasto: "",
        nazwa: "",
        nip: "",
        pesel: "",
        regon: "",
        rodzaj: 0,
        telefon: "",
        ulica: ""
    },
    limitkm: 0,
    limitkm_rodzaj: 0,
    limitkm_rodzaj_lista: [],
    nr_rej_w_naprawie: "",
    umowa_nr: 0,
    umowa_mc: 0,
    umowa_rok: 0,
    nr_zlecenia: "",
    opis: "",
    ryczalt: "",
    ryczalt_rodzaj: 0,
    ryczalt_rodzaj_lista: [],
    stawka_pow_limit: "",
    wynajem_id: 0
};

ReservationDialog.propTypes = {
    rentType: PropTypes.string,
    isEdit: PropTypes.bool,
    dialogOpenCallback: PropTypes.func,
    carId: PropTypes.number,
    onPutPool: PropTypes.func,
    onPutRent: PropTypes.func,
    onPutPoolAndClose: PropTypes.func,
    onPutRentAndClose: PropTypes.func,
    onAddPool: PropTypes.func,
    onAddRent: PropTypes.func,
    onDeletePool: PropTypes.func,
    onDeleteRent: PropTypes.func,
    //redux
    remarks: PropTypes.array,
    changes: PropTypes.array
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReservationDialog);
